document.addEventListener("DOMContentLoaded", () => {
  const siteMain = document.querySelector('.site-main');
  if(siteMain){
    setMainPaddingBottom();
    window.addEventListener("resize", setMainPaddingBottom);
    window.addEventListener("orientationchange", setMainPaddingBottom);
  }
});
function setMainPaddingBottom() {
  const footer = document.querySelector(".site-footer");
  const main = document.querySelector(".site-main");
  footerHeight = footer.offsetHeight;

  main.style.paddingBottom = footerHeight + "px";
  main.style.marginBottom = "-" + footerHeight + "px";
}
